import request from '@/utils/request'


// 查询视频-流量池列表
export function listVideoFlowPool(query) {
  return request({
    url: '/platform/video-flow-pool/list',
    method: 'get',
    params: query
  })
}

// 查询视频-流量池分页
export function pageVideoFlowPool(query) {
  return request({
    url: '/platform/video-flow-pool/page',
    method: 'get',
    params: query
  })
}

// 查询视频-流量池详细
export function getVideoFlowPool(data) {
  return request({
    url: '/platform/video-flow-pool/detail',
    method: 'get',
    params: data
  })
}

// 新增视频-流量池
export function addVideoFlowPool(data) {
  return request({
    url: '/platform/video-flow-pool/add',
    method: 'post',
    data: data
  })
}

// 修改视频-流量池
export function updateVideoFlowPool(data) {
  return request({
    url: '/platform/video-flow-pool/edit',
    method: 'post',
    data: data
  })
}

// 删除视频-流量池
export function delVideoFlowPool(data) {
  return request({
    url: '/platform/video-flow-pool/delete',
    method: 'post',
    data: data
  })
}
